var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.70312 13.7812C10.7838 13.7812 13.2812 11.2838 13.2812 8.20312C13.2812 5.12241 10.7838 2.625 7.70312 2.625C4.62241 2.625 2.125 5.12241 2.125 8.20312C2.125 11.2838 4.62241 13.7812 7.70312 13.7812Z","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M11.6484 12.1484L14.8758 15.3758","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Search.defaultProps = {"width":"17","height":"18","viewBox":"0 0 17 18","fill":"none"};

module.exports = Search;

Search.default = Search;
